var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.87572 0 0 .87572 -25.922 -8.8061)",
    fill: "#7fb539",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.297 10.291c-4.1102 0-7.4629 3.3546-7.4629 7.4648s3.3526 7.4629 7.4629 7.4629 7.4648-3.3527 7.4648-7.4629-3.3546-7.4648-7.4648-7.4648zm0 2c3.0294 0 5.4648 2.4355 5.4648 5.4648 0 3.0294-2.4355 5.4629-5.4648 5.4629s-5.4629-2.4335-5.4629-5.4629c0-3.0294 2.4335-5.4648 5.4629-5.4648z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.305 24.193c-5.4681 0-10.158 3.2715-12.256 7.9609-1.0591 2.3639 0.77018 5.0723 3.3438 5.0723h17.824c2.5736 0 4.4009-2.7084 3.3418-5.0723-2.1041-4.6877-6.7859-7.9609-12.254-7.9609zm0 2c4.6716 0 8.6358 2.7828 10.43 6.7793 0.48286 1.0777-0.31655 2.2539-1.5176 2.2539h-17.824c-1.201 0-2.0004-1.1762-1.5176-2.2539a1.0001 1.0001 0 0 0 0-2e-3c1.7874-3.9947 5.758-6.7773 10.43-6.7773z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.18858dab.svg";
export { ForwardRef as ReactComponent };